import React from "react";

import SignInPage from "pages/App/SignInPage";
import NavBarTop from "pages/App/NavBarTop";
import NavRail from "pages/App/NavRail";
import AppContent from "pages/App/AppContent";

import useAuth from "hooks/useAuth";

function AppContentContainer() {
  const { authenticated, activated } = useAuth();

  if (!authenticated) {
    return <SignInPage />;
  }

  return (
    <div className="app-container">
      <NavRail />
      <div className="app-content">
        <NavBarTop />
        <AppContent activated={activated} />
      </div>
    </div>
  );
}

AppContentContainer.propTypes = {};

export default AppContentContainer;
